import React, { useState, useEffect, useContext } from "react";
import classes from "./GetHistory.module.css";
import PermissionContext from "../../Store/permission-context";
import DatePicker, {
  DateObject,
  getAllDatesInRange,
} from "react-multi-date-picker";
// import { DateRangePicker } from "rsuite";
import { Row, Col, Card, Button, Table } from "react-bootstrap";
import { Divider } from "rsuite";
import ProcessingModal from "./Modals/ProcessingModal";

const GetHistory = () => {
  const [Dates, setDates] = useState("");
  const [Dates2, setDates2] = useState("");
  const [AllDates, setAllDates] = useState([]);
  const [DateCategory, setDateCategory] = useState("specific");
  const [DatesSelected, setDatesSelected] = useState([]);
  const [SingleDate, setSingleDate] = useState("");

  const [disableButton, setdisableButton] = useState(false);
  const [causeChange, setcauseChange] = useState(false);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [ShowProcessing, setShowProcessing] = useState(false);
  const [AllCustomerRecords, setAllCustomerRecords] = useState([]);
  const [AllMonths, setAllMonths] = useState([]);
  const [Title, setTitle] = useState("");
  const PCtx = useContext(PermissionContext);

  const GetTheHistory = async () => {
    if (StartDate != "" && EndDate != "") {
      setShowProcessing(true);
      let TheDates = { Start: StartDate, End: EndDate };
      let CustomerRecords = await PCtx.connectAxios(
        "getcustomerrecords.php",
        TheDates
      );

      setAllMonths(CustomerRecords.Months);
      setAllCustomerRecords(CustomerRecords.Records);
      setShowProcessing(false);
    } else {
      PCtx.displayAlert(
        "INCOMPLETE INFORMATION",
        "Please Select the Start date and the End date. You only need to pick a day in the desired month",
        "danger"
      );
    }
  };

  return (
    <Row className={classes.margin4printing}>
      <Col md={12} className={classes.margin4printing}>
        <Row className={classes.hide4printing}>
          <Col md={12}>
            <Card style={{ height: "35px" }}>
              <Card.Body>
                <h4
                  className="text-center "
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  <Divider className="m-0">
                    RECORDS OF REGISTERED CUSTOMERS
                  </Divider>
                </h4>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className={classes.hide4printing}>
          <Col md={12}>
            <Card style={{ minHeight: "60px" }}>
              <Card.Body className="m-0 p-0">
                <Row className="justify-content-around align-items-center">
                  <Col md={3} sm={12} xs={12} className="text-center">
                    <label
                      className={classes.labelradio}
                      style={{ fontSize: "16px", color: "red" }}
                    >
                      From which Month and Year?
                      <br />
                      <DatePicker
                        value={Dates}
                        editable={false}
                        style={{ border: "1px solid brown", height: "30px" }}
                        placeholder="Click me to open calendar!"
                        onChange={(dateObjects) => {
                          setDates(dateObjects);
                          setStartDate(dateObjects.toString());
                        }}
                        format="MMM DD, YYYY"
                        shadow={true}
                      />
                    </label>
                  </Col>
                  <Col md={3} sm={12} xs={12} className="text-center">
                    -
                  </Col>
                  <Col md={3} sm={12} xs={12} className="text-center">
                    <label
                      className={classes.labelradio}
                      style={{ fontSize: "16px", color: "green" }}
                    >
                      To which Month and Year?
                      <br />
                      <DatePicker
                        value={Dates2}
                        editable={false}
                        style={{ border: "1px solid brown", height: "30px" }}
                        placeholder="Click me to open calendar!"
                        onChange={(dateObjects) => {
                          setDates2(dateObjects);
                          setEndDate(dateObjects.toString());
                        }}
                        format="MMM DD, YYYY"
                        shadow={true}
                      />
                    </label>
                  </Col>
                  <Col
                    md={3}
                    sm={12}
                    xs={12}
                    className="align-self-center text-center"
                  >
                    <Button
                      variant="info"
                      onClick={GetTheHistory}
                      disabled={disableButton}
                      style={{ backgroundColor: "brown", color: "white" }}
                    >
                      Generate History
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Divider>
            <Col md={12} lg={12} sm={12} xs={12}>
              {AllMonths.length > 0 && (
                <h3
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                  className="text-center"
                >
                  Total Money spent by Registered Customers from {AllMonths[2]}{" "}
                  to {AllMonths[AllMonths.length - 2]}{" "}
                </h3>
              )}
            </Col>
          </Divider>
          <Col md={12} lg={12} sm={12} xs={12}>
            <Table striped bordered responsive>
              <thead>
                <tr>
                  {AllMonths.map((mth, index) => (
                    <th key={index} className="text-center">
                      {mth}{" "}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {AllCustomerRecords.map((Rec, ind) => (
                  <tr>
                    {Rec.map((cr, inx) => (
                      <td className="text-center">{Rec[inx]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Col>
      {ShowProcessing && <ProcessingModal Show={ShowProcessing} />}
    </Row>
  );
};

export default GetHistory;
